import { useTranslation } from 'react-i18next';
import i18n from '@/i18n';
import traditionalChineseText from '@/i18n/zh-TW/shared/ui/SharedUi.zlf';
import englishText from '@/i18n/en-US/shared/ui/SharedUi.zlf';

const SHARED_UI_NAMESPACE = 'zlf:shared/ui/SharedUi';

// 共用元件（關閉鈕、分頁、圖示按鈕）每個畫面都會用到，翻譯必須在第一次渲染前就備妥，
// 所以靜態匯入，不走 usePageTranslation 的非同步載入。
i18n.addResourceBundle('zh-TW', SHARED_UI_NAMESPACE, traditionalChineseText, true, true);
i18n.addResourceBundle('en-US', SHARED_UI_NAMESPACE, englishText, true, true);

export function useSharedUiText() {
    const { t } = useTranslation(SHARED_UI_NAMESPACE);
    return t;
}
